import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { DatePicker as MuiDatePicker } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { useState } from 'react'
import styled from 'styled-components'

// import T from 'prop-types'
import Input from '../Input'

const defaultProps = {}
const propTypes = {}

const StyledDatePicker = styled(MuiDatePicker)`
  margin-top: 0 !important;
`

export const DatePicker = () => {
  const [value, setValue] = useState(null)

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <StyledDatePicker
        label="Basic example"
        value={value}
        onChange={newValue => {
          setValue(newValue)
        }}
        slots={{ textField: Input }}
      />
    </LocalizationProvider>
  )
}

DatePicker.defaultProps = defaultProps
DatePicker.propTypes = propTypes

export default DatePicker
